import { render } from "./Content_reason.vue?vue&type=template&id=59724ad5&scoped=true"
import script from "./Content_reason.vue?vue&type=script&lang=js"
export * from "./Content_reason.vue?vue&type=script&lang=js"

import "./Content_reason.vue?vue&type=style&index=0&id=59724ad5&scoped=true&lang=css"

import exportComponent from "/Users/news/Desktop/source/topic_freddy/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59724ad5"]])